import { pure, compose, withState, withHandlers } from 'react-recompose';
// helpers/constants
import * as G from '../../helpers';
//////////////////////////////////////////////////

export const enhance = compose(
  withState('value', 'setValue', null),
  withHandlers({
    handleChange: ({ setValue, setOutsideValue }) => (value) => {
      setValue(value);

      G.callFunctionWithArgs(setOutsideValue, value);
    },
    handleSelect: (props) => async (value) => {
      const { setValue, resultCallback, setOutsideValue } = props;

      const result = await G.geocodeByPlaceAddress(value, 'components -> PlacesAutocompleteInput');

      const { formattedAddress } = result;

      setValue(formattedAddress);

      G.callFunctionWithArgs(resultCallback, result);
      G.callFunctionWithArgs(setOutsideValue, formattedAddress);
    },
  }),
  pure,
);

export const getValue = (props) => {
  const { value, outsideValue, useOutsideValue } = props;

  if (G.isTrue(useOutsideValue)) return outsideValue;

  return value;
};
